import React from "react"
import { Box, Dialog, DialogContent, styled, Typography, IconButton } from "@mui/material"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"
import { Formik } from "formik"
import { validationSchemaCountryModal } from "helpers/validationSchema"
import CloseIcon from "@mui/icons-material/Close"
import { useTheme } from "@mui/system"
import { addMenuCountryAction } from "redux/DMV/actions"
import { useDispatch } from "react-redux"

const buttonText = {
  CANCEL: "Cancel",
  SAVE: "Save"
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: "transparent"
  },
  "& .MuiDialogContent-root": {
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    border: "none",
    width: 580,
    padding: 35,
    boxSizing: "border-box"
  }
}))

function CountryModal({ open = false, onClose = () => {} }) {
  const theme = useTheme()
  const dispatch = useDispatch()

  const styles = {
    closeBtn: {
      color: theme.palette.text.primary,
      position: "absolute",
      top: "10px",
      right: "10px",
      backgroundColor: theme.palette.background.main
    }
  }

  function handleButton(formik, btnValue) {
    if (btnValue?.trim() === buttonText.CANCEL) {
      onClose()
    } else if (btnValue?.trim() === buttonText.SAVE) {
      const payload = {
        name: formik.values?.country ?? "",
        restaurant: "3e01ef87-42f3-42f5-8a50-9556a459d8e9"
      }
      dispatch(addMenuCountryAction({ payload, onClose }))
    }
  }

  return (
    <StyledDialog open={open}>
      <DialogContent>
        <Box className="d-flex justify-content-end">
          <IconButton onClick={() => onClose()} sx={styles.closeBtn}>
            <CloseIcon sx={{ height: "14px", width: "14px" }} />
          </IconButton>
        </Box>
        <Box className="w-100 d-flex justify-content-center mb-2">
          <Typography variant="h2">Add New Wine Region Country</Typography>
        </Box>
        <Formik
          initialValues={{
            country: ""
          }}
          enableReinitialize={true}
          validationSchema={validationSchemaCountryModal}>
          {(formik) => (
            <>
              <Box flexDirection="column" className="mt-4">
                <React.Fragment>
                  <Box className="d-flex justify-content-between w-100 py-2">
                    <AppTextField
                      id="country"
                      name="country"
                      fullWidth
                      isUpperCase={!false}
                      label={`Country`}
                      isRequired={true}
                      placeholder="Enter Country"
                      value={formik.values.country}
                      onChange={formik.handleChange}
                      error={formik.touched.country && Boolean(formik.errors.country)}
                      helperText={formik.errors.country}
                    />
                  </Box>
                </React.Fragment>
              </Box>
              <Box className="mt-5 d-flex justify-content-around">
                <AppButton
                  disabled={Boolean(formik?.errors.country) || formik?.values.country?.length === 0}
                  onClick={(e) => handleButton(formik, e.target.innerText)}
                  sx={{ height: "48px", width: 150 }}
                  variant="outlined">
                  {buttonText.SAVE}
                </AppButton>
                <AppButton
                  onClick={(e) => handleButton(formik, e.target.innerText)}
                  sx={{ height: "48px", width: 150 }}
                  variant="outlined">
                  {buttonText.CANCEL}
                </AppButton>
              </Box>
            </>
          )}
        </Formik>
      </DialogContent>
    </StyledDialog>
  )
}

export default CountryModal
